import React, { useState, useEffect } from 'react';
import './index.css';
import { isValidUser } from '../Utils/authUtils';
import { ICONS } from '@ohif/ui';
import classnames from 'classnames';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _authUrls } from '@custom/Utils/constants/apiUrls';
import { SuccessModal } from '@ohif/ui';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { resetPasswordValidationSchema, resetPasswordInitialValues } from './helper/schema';
import { ResetPasswordFormTypes } from './helper/auth';
import { useDispatch, useSelector } from 'react-redux';
import resetPasswordApi from '../rtk-apis/authentication/resetPassword';
import { AppDispatch,RootState } from '../store/store';

const ResetPassword = () => {

  const navigate = useNavigate();
  const location = useLocation()
  const { email } = location?.state || {}

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false)

  const dispatch = useDispatch<AppDispatch>();
  const data = useSelector((state: RootState) => state?.resetPassword);

  const handleSubmit = async (values: ResetPasswordFormTypes, { setErrors }) => {
    try {
      const body = {
        email,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword
      }
      // Dispatch loginApi and await the result, unwrapping the response
      const response = await dispatch(resetPasswordApi(body)).unwrap(); // Extract actual payload

      if (response?.status == "SUCCESS") {
        // display success for 2 sec then redirect
        setSuccessPopup(true);
        setTimeout(() => {
          setSuccessPopup(false);
          navigate('/login');
        }, 500);
      } else {
        setErrors({ apiErr: 'Failed to reset password. Please try again.' });
      }
    } catch (error) {
      setErrors({ apiErr: 'An error occurred. Please try again later.' });
    }
  };

  useEffect(() => {
    if (isValidUser() || email === undefined) {
      navigate('/dashboard');
    }
  }, []);

  return (
    <>
      <div className={classnames("h-screen w-full bg-cover bg-no-repeat bg-center")}
        style={{
          backgroundImage: "url('/assets/BG.jpg')",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }} >
        <img src={`${ICONS.Logo}`} className='logo' alt="Seven Hills Logo" />
        <div className={classnames("login-container w-[400px] h-[420px] p-6 bg-white text-black m-0 mx-auto rounded-lg transform -translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 border border-gray-300 shadow-lg")}>
          <div className={classnames("flex flex-col justify-center items-center mb-4")}>
            <img className='w-12 h-12 mb-2' src={`${ICONS.ResetLock}`} alt="User_Icon" />
            <h1 className={classnames('text-black font-semibold text-xl')}>Reset Password</h1>
          </div>
          <Formik
            initialValues={resetPasswordInitialValues}
            validationSchema={resetPasswordValidationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <div>
                  <div className={classnames("flex flex-col gap-[3px] my-[15px]")}>
                    <label className={`${classnames('text-gray-900 mb-1')} email_text`} htmlFor='email'>Password</label>
                    <div className='relative'>
                      <img
                        className={classnames('absolute w-3 top-1/2 left-2 transform -translate-y-1/2 ml-2')}
                        src={`${ICONS.LockIcon}`}
                        alt="Lock icon"
                      />
                      <Field
                        name="newPassword"
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Enter your password"
                        className={classnames('bg-white text-black w-full h-[35px] bg-none border border-gray-500 border-opacity-40 rounded-lg pl-8 pr-8 p-3 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600')}
                      />
                      <img
                        className={classnames('absolute w-6 top-1/2 right-2 transform -translate-y-1/2 cursor-pointer')}
                        src={`${ICONS.PasswordEye}`}
                        alt="password eye"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    </div>
                    <ErrorMessage name="password" component="div" className="text-red-500 text-xs" />
                  </div>
                  <div className={classnames("flex flex-col gap-[3px] my-[15px] mt-4")}>
                    <label className='text-gray-900 mb-1 password_text' htmlFor='password'>Confirm Password</label>
                    <div className='relative w-full'>
                      <img
                        className={classnames('absolute w-3 top-1/2 left-2 transform -translate-y-1/2 ml-2')}
                        src={`${ICONS.LockIcon}`}
                        alt="Lock icon"
                      />
                       <Field
                        name="confirmPassword"
                        type={showConfirmPassword ? 'text' : 'password'}
                        placeholder="Re-enter your password"
                        className={classnames('bg-white text-black w-full h-[35px] bg-none border border-gray-500 border-opacity-40 rounded-lg pl-8 pr-8 p-3 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600')}
                      />
                      <img
                        className={classnames('absolute w-6 top-1/2 right-2 transform -translate-y-1/2 cursor-pointer')}
                        src={`${ICONS.PasswordEye}`}
                        alt="password eye"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      />
                    </div>
                    <ErrorMessage name="confirmPassword" component="div" className="text-red-500 text-xs" />
                  </div>
                  <ErrorMessage name="apiErr" component="div" className="text-red-500 text-xs" />
                  <div className='mt-5 w-full mb-1'>
                    <button type='submit' style={{ backgroundColor: '#0F8491' }} className=' rounded-md w-full p-2 bg-primary text-white'>Done</button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <SuccessModal
        isSuccessModalOpen={successPopup}
        title={'Password Changed Successfully.'}
        handleCloseModal={() => setSuccessPopup(false)}
      />
    </>
  );
};
export default ResetPassword;
